import * as Yup from 'yup'

const CategoryAddEditSchema = Yup.object().shape({
  category_name: Yup.string()
    .min(2, 'Category name minimum 2 characters')
    .max(50, 'Category name maximum 50 characters')
    .required('Category name is required'),
  status: Yup.string().required('Status is required')
})

export const BusinessUnitAddEditSchema = Yup.object().shape({
  name: Yup.string()
    .max(50, 'Name maximum 50 characters')
    .required('Name is required'),
  status: Yup.string().required('Status is required')
})

const UserAddSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'name minimum 2 characters')
    .max(50, 'name maximum 50 characters')
    .required('name is required'),
  username: Yup.string()
    .min(2, 'Username minimum 2 characters')
    .max(50, 'Username maximum 50 characters')
    .required('Username is required'),
  password: Yup.string()
    .min(8, 'Password minimum 8 characters')
    .max(20, 'Password maximum 20 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~])/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol'
    )
    .required('Password is required')
})

const UserEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'name minimum 2 characters')
    .max(50, 'name maximum 50 characters')
    .required('name is required'),
  username: Yup.string()
    .min(2, 'Username minimum 2 characters')
    .max(50, 'Username maximum 50 characters')
    .required('Username is required'),
  password: Yup.string()
    .transform((value) => (value === '' ? undefined : value))
    .nullable()
    .min(8, 'Password minimum 8 characters')
    .max(20, 'Password maximum 20 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~])/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol'
    )
})

const RoleAddEditSchema = Yup.object().shape({
  role_code: Yup.string()
    .min(2, 'Role code minimum 2 characters')
    .max(50, 'Role code maximum 50 characters')
    .required('Role code is required'),
  role_name: Yup.string()
    .min(2, 'Role name minimum 2 characters')
    .max(50, 'Role name maximum 50 characters')
    .required('Role name is required')
})

const loginSchema = Yup.object().shape({
  username: Yup.string()
    .min(3, 'Username minimum 3 character')
    .required('Username is required'),
  password: Yup.string().required('Password is required')
})

const expeditionRentAddEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Expedition/rent name minimum 2 characters')
    .max(50, 'Expedition/rent name maximum 50 characters')
    .required('Expedition/rent name is required'),
  phone: Yup.number()
    .typeError('Phone number must be a number')
    .required('Phone number is required'),
  address: Yup.string()
    .min(2, 'Address minimum 2 characters')
    .max(100, 'Address maximum 100 characters')
    .required('Address is required'),
  status: Yup.string().required('Status is required')
})

const BatchAddEditSchema = Yup.object().shape({
  item_id: Yup.string().required('Item id is required'),
  exp_date: Yup.date().required('Expired date is required'),
  manufacturing_date: Yup.date().required('Manufacturing date is required'),
  batch: Yup.string()
    .required('Batch is required')
    .min(2, 'Batch minimum 2 character')
    .max(30, 'Batch maximum 30 character'),
  note: Yup.string().max(100, 'Note maximum 100 character')
})

const VehicleAddEditSchema = Yup.object().shape({
  plate_no: Yup.string()
    .min(2, 'Plate number minimum 2 characters')
    .max(20, 'Plate number maximum 20 characters')
    .required('Plate number is required'),
  vehicle_type: Yup.string()
    .min(2, 'Vehicle type minimum 2 characters')
    .max(50, 'Vehicle type maximum 50 characters')
    .required('Vehicle type is required'),
  volume: Yup.number().required('Volume is required'),
  length: Yup.number().required('Length is required'),
  width: Yup.number().required('Width is required'),
  height: Yup.number().required('Height is required'),
  capacity: Yup.number().required('Capacity is required'),
  status: Yup.string().required('Status is required'),
  typeVehicle: Yup.boolean(),
  stnk_doc: Yup.mixed().when(['typeVehicle'], {
    is: (typeVehicle) => typeVehicle,
    then: (schema) =>
      schema
        .required('File STNK is required')
        .test('formatFile', 'Only files below are allowed', (value) => {
          if (value && value.type) {
            const supportedFormats = [
              'image/jpeg',
              'image/png',
              'image/webp',
              'application/pdf'
            ]
            return supportedFormats.includes(value.type)
          }
          return true
        })
        .test('fileSize', 'File size must not be more than 3MB', (value) => {
          if (value && value.size) {
            return value.size <= 3145728
          }
          return true
        }),
    otherwise: (schema) => schema.notRequired()
  })
})

const AreaAddEditSchema = Yup.object().shape({
  code: Yup.string()
    .min(1, 'Area code minimum 1 character')
    .max(50, 'Area code maximum 50 character')
    .required('Area code name is required'),
  area_name: Yup.string()
    .min(1, 'Area name minimum 1 character')
    .max(50, 'Area name maximum 50 character')
    .required('Area name is required')
})

const BranchUpdateSchema = Yup.object().shape({
  code: Yup.string().required('Code branch is required'),
  name: Yup.string().required('Name branch is required'),
  description: Yup.string()
    .min(3, 'Description branch minimum 3 character')
    .max(200, 'Description branch maximum 200 character')
    .required('Description branch is required')
})

const SectorUpdateSchema = Yup.object().shape({
  warehouse_customer: Yup.object(),
  warehouse_code: Yup.string().required(),
  warehouse_name: Yup.string().required(),
  warehouse_location: Yup.string().required(),
  warehouse_type: Yup.string().required()
})

const StagingAreaAddSchema = Yup.object().shape({
  staging_name: Yup.string()
    .min(2, 'Staging area name minimum 2 characters')
    .max(30, 'Staging area name maximum 30 characters')
    .required('Staging area name is required'),
  block_total: Yup.number().required('Total block is required')
})

const DriverAddSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name minimum 2 characters')
    .max(50, 'Name maximum 50 characters')
    .required('Name is required'),
  status: Yup.string().required('Status is required'),
  typeDriver: Yup.string().required('Type driver is required'),
  phone_number: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(8, 'Phone number minimum 8 digits')
        .max(15, 'Phone number maximum 15 digits')
        .required('Phone number is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  address: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(2, 'Address minimum 2 characters')
        .max(250, 'Address maximum 200 characters')
        .required('Address is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  username: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(2, 'Username minimum 2 characters')
        .max(100, 'Username maximum 100 characters')
        .required('Username is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  password: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(8, 'Password minimum 8 characters')
        .max(20, 'Password maximum 20 characters')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~])/,
          'Password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol'
        )
        .required('Password is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  sim_doc: Yup.mixed().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'external',
    then: (schema) =>
      schema
        .required('File SIM is required')
        .test('formatFile', 'Only files below are allowed', (value) => {
          if (value && value.type) {
            const supportedFormats = [
              'image/jpeg',
              'image/png',
              'image/webp',
              'application/pdf'
            ]
            return supportedFormats.includes(value.type)
          }
          return true
        })
        .test('fileSize', 'File size must not be more than 3MB', (value) => {
          if (value && value.size) {
            return value.size <= 3145728
          }
          return true
        }),
    otherwise: (schema) => schema.notRequired()
  }),
  ktp_doc: Yup.mixed().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'external',
    then: (schema) =>
      schema
        .required('File KTP is required')
        .test('formatFile', 'Only files below are allowed', (value) => {
          if (value && value.type) {
            const supportedFormats = [
              'image/jpeg',
              'image/png',
              'image/webp',
              'application/pdf'
            ]
            return supportedFormats.includes(value.type)
          }
          return true
        })
        .test('fileSize', 'File size must not be more than 3MB', (value) => {
          if (value && value.size) {
            return value.size <= 3145728
          }
          return true
        }),
    otherwise: (schema) => schema.notRequired()
  })
})

const DriverEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name minimum 2 characters')
    .max(100, 'Name maximum 100 characters')
    .required('Name is required'),
  status: Yup.string().required('Status is required'),
  typeDriver: Yup.string().required('Type driver is required'),
  phone_number: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(8, 'Phone number minimum 8 digits')
        .max(15, 'Phone number maximum 15 digits')
        .required('Phone number is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  address: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(2, 'Address minimum 2 characters')
        .max(250, 'Address maximum 200 characters')
        .required('Address is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  username: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .min(2, 'Username minimum 2 characters')
        .max(50, 'Username maximum 50 characters')
        .required('Username is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  password: Yup.string().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'internal',
    then: (schema) =>
      schema
        .transform((value) => (value === '' ? undefined : value))
        .nullable()
        .min(8, 'Password minimum 8 characters')
        .max(20, 'Password maximum 20 characters')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~])/,
          'Password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol'
        ),

    otherwise: (schema) => schema.notRequired()
  }),
  sim_doc: Yup.mixed().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'external',
    then: (schema) =>
      schema
        .required('File SIM is required')
        .test('formatFile', 'Only files below are allowed', (value) => {
          if (value && value.type) {
            const supportedFormats = [
              'image/jpeg',
              'image/png',
              'image/webp',
              'application/pdf'
            ]
            return supportedFormats.includes(value.type)
          }
          return true
        })
        .test('fileSize', 'File size must not be more than 3MB', (value) => {
          if (value && value.size) {
            return value.size <= 3145728
          }
          return true
        }),
    otherwise: (schema) => schema.notRequired()
  }),
  ktp_doc: Yup.mixed().when(['typeDriver'], {
    is: (typeDriver) => typeDriver === 'external',
    then: (schema) =>
      schema
        .required('File KTP is required')
        .test('formatFile', 'Only files below are allowed', (value) => {
          if (value && value.type) {
            const supportedFormats = [
              'image/jpeg',
              'image/png',
              'image/webp',
              'application/pdf'
            ]
            return supportedFormats.includes(value.type)
          }
          return true
        })
        .test('fileSize', 'File size must not be more than 3MB', (value) => {
          if (value && value.size) {
            return value.size <= 3145728
          }
          return true
        }),
    otherwise: (schema) => schema.notRequired()
  })
})

const RackAddEditSchema = Yup.object().shape({
  rack_name: Yup.string()
    .max(50, 'Rack name maximum 50 characters')
    .required('Rack name is required')
    .typeError('Rack name must be a string'),
  total_beam: Yup.number()
    .integer('Total beam must be an integer')
    .min(1, 'Total beam minimum 1')
    .required('Total beam is required'),
  total_level: Yup.number()
    .integer('Total level must be an integer')
    .min(1, 'Total level minimum 1')
    .required('Total level is required'),
  area_id: Yup.string().required('Area is required'),
  type: Yup.string()
    .oneOf(
      ['rack', 'ground', 'double', 'shelving'],
      'Type must be one of: Selective, Ground Floor, Double Deep, Shelving'
    )
    .required('Type is required')
})

const RackAddSchema = RackAddEditSchema.shape({
  warehouse_id: Yup.string().required('Warehouse ID is required'),
  total_slot: Yup.number()
    .integer('Total slot must be an integer')
    .min(1, 'Total slot minimum 1')
    .required('Total slot is required')
    .typeError('Total slot must be a number')
})

const PurchaseReceiptCreateImportSchema = Yup.object().shape({
  do: Yup.string()
    .min(2, 'DO minimum 2 characters')
    .max(50, 'DO maximum 50 characters')
    .required('DO is required'),
  pib_date: Yup.date().required('PIB date is required'),
  aju: Yup.string().required('AJU is required'),
  expedition: Yup.string()
    .min(2, 'Expedition minimum 2 characters')
    .max(50, 'Expedition maximum 50 characters')
    .required('Expedition is required'),
  pic_name: Yup.string()
    .min(2, 'PIC name minimum 2 characters')
    .max(50, 'PIC name maximum 50 characters')
    .required('PIC name is required'),
  pic_number: Yup.number().required('PIC number is required'),
  series_number: Yup.string().required('Series is required')
})

const PurchaseReceiptCreateLocalSchema = Yup.object().shape({
  do: Yup.string()
    .min(2, 'DO minimum 2 characters')
    .max(50, 'DO maximum 50 characters')
    .required('DO is required'),
  expedition: Yup.string()
    .min(2, 'Expedition minimum 2 characters')
    .max(50, 'Expedition maximum 50 characters')
    .required('Expedition is required'),
  pic_name: Yup.string()
    .min(2, 'PIC name minimum 2 characters')
    .max(50, 'PIC name maximum 50 characters')
    .required('PIC name is required'),
  pic_number: Yup.number().required('PIC number is required'),
  series_number: Yup.string().required('Series is required')
})

const PurchaseOrderPackingCreateSchema = Yup.object().shape({
  po_num: Yup.string().required('PO number is required'),
  pr_type: Yup.string().required('PO type is required'),
  expedition: Yup.string().required('Expedition is required'),
  branch: Yup.string().required('Branch is required'),
  supplier: Yup.string().required('Supplier is required'),
  series_number: Yup.string().required('Series is required'),
  accepted_warehouse: Yup.string().required('Accepted warehouse is required'),
  pr_method: Yup.string().required('PR method is required'),
  do: Yup.string().required('DO is required'),
  pib_date: Yup.string().when('pr_type', {
    is: 'import',
    then: (schema) => schema.required('PIB date is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  aju: Yup.string().when('pr_type', {
    is: 'import',
    then: (schema) => schema.required('AJU is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  pic_name: Yup.string().required('PIC name is required'),
  pic_number: Yup.string().required('PIC number is required'),
  vehicles: Yup.array()
    .of(
      Yup.object().shape({
        plate_no: Yup.string().required('Plate number is required'),
        sim_validity: Yup.string().required('SIM validity is required'),
        stnk_validity: Yup.string().required('STNK validity is required'),
        sim_notes: Yup.string().max(50, 'Maksimal 50 karakter'),
        stnk_notes: Yup.string().max(50, 'Maksimal 50 karakter'),
        stnk_doc: Yup.string().required('STNK is required'),
        sim_doc: Yup.string().required('SIM document is required')
      })
    )
    .test('min-vehicles', 'Please add at least one vehicle', (value) => {
      return value && value.length > 0
    })
    .required('Vehicle are required'),
  packings: Yup.array()
    .of(
      Yup.object().shape({
        item_name: Yup.string().required('Item name is required'),
        total_pack: Yup.number().required('Total pack is required')
      })
    )
    .test('min-items', 'Please add at least one item to packings', (value) => {
      return value && value.length > 0
    })
    .required('Packings are required')
})

const ModalUpdateVehiclePR = Yup.object().shape({
  sim_validity: Yup.string().required('Please select an option'),
  stnk_validity: Yup.string().required('Please select an option'),
  sim_doc: Yup.string().required('Please upload sim document'),
  stnk_doc: Yup.string().required('Please upload stnk document'),
  sim_notes: Yup.string().max(50, 'Maksimal 50 karakter'),
  stnk_notes: Yup.string().max(50, 'Maksimal 50 karakter')
})

const ChangePasswordSchema = Yup.object().shape({
  CurrentPassword: Yup.string().required('Current password is required'),
  NewPassword: Yup.string()
    .min(8, 'New password minimum 8 characters')
    .max(20, 'New password maximum 20 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~])/,
      'New password must contain at least one uppercase letter, one lowercase letter, one number, and one symbol'
    )
    .required('New password is required'),
  ConfirmPassword: Yup.string()
    .oneOf(
      [Yup.ref('NewPassword')],
      'New password dan confirm password harus sama'
    )
    .required('Confirm password is required')
})

const CreateSoSjSchema = Yup.object().shape({
  item: Yup.string().required('item is required'),
  batch: Yup.string().required(),
  pack: Yup.number()
    .min(1, 'pack minimum 1')
    .required('pack is required, minimum 1')
})

const UpdateSoSjSchema = Yup.object().shape({
  batch: Yup.string().required('batch is required'),
  pack: Yup.number()
    .min(1, 'pack minimum 1')
    .required('pack is required, minimum 1')
})

const CreateMasterPalet = Yup.object().shape({
  palet_id: Yup.string().required('Palet ID is required')
})

const updateCOA = Yup.object().shape({
  coa_pd: Yup.date().required('COA PD is required'),
  coa_ed: Yup.date().required('COA ED is required'),
  total_pack: Yup.number().required('Total pack is required'),
  receiving_uom: Yup.string().required('Receiving UOM is required')
})

const updateCOACrossDockOrTypeExternal = Yup.object().shape({
  coa_pd: Yup.date().required('COA PD is required'),
  coa_ed: Yup.date().required('COA ED is required'),
  label_pd: Yup.date().required('Label PD is required'),
  label_ed: Yup.date().required('Label ED is required')
})

const dimensionSchema = Yup.object().shape({
  length: Yup.number().required('Length is required'),
  width: Yup.number().required('Width is required'),
  height: Yup.number().required('Height is required')
})

const deliveryConfirmationUpdateItem = Yup.object().shape({
  qty: Yup.number().required('Pack qty is required')
})

const MapEditorSchema = Yup.object().shape({
  rack: Yup.object().required('Rack is required'),
  beam: Yup.object().required('Beam is required'),
  slot: Yup.object().required('Slot is required'),
  area: Yup.object().required('Area is required'),
  type_id: Yup.array().optional()
})

const MapEditorGroundSchema = Yup.object().shape({
  rack: Yup.object().required('Rack is required'),
  beam: Yup.object().required('Beam is required'),
  slot: Yup.object().required('Slot is required'),
  area: Yup.object().required('Area is required')
})

const MapEditorStagingAreaSchema = Yup.object().shape({
  staging_id: Yup.object().required('Staging is required'),
  blok_id: Yup.object().required('Blok is required')
})

const AddItemProblemSjSchema = Yup.object().shape({
  item_code: Yup.string().required('Item code is required'),
  item_batch_id: Yup.string().required('Item batch is required'),
  total_pack: Yup.number()
    .min(1, 'Pack minimum 1')
    .required('Total Pack is required, minimum 1')
})

const UpdateRequestSjSchema = Yup.object().shape({
  item_code: Yup.string().required('Item code is required'),
  batch_id: Yup.string().required('Batch is required'),
  total_pack_batch: Yup.number()
    .min(1, 'Pack minimum 1')
    .required('Total Pack is required, minimum 1'),
  total_pack: Yup.number()
    .min(1, 'Total Pack minimum 1')
    .max(
      Yup.ref('total_pack_batch'),
      'Total Pack cannot exceed available pack on batch'
    )
    .required('Total Pack is required, minimum 1')
})

const AddPrTypeSchemaPr = Yup.object().shape({
  po: Yup.string().required('PO is required'),
  type: Yup.string().required('Type is required'),
  method: Yup.string().required('Method is required')
})

const AddPrTypeSchemaPo = Yup.object().shape({
  type: Yup.string().required('Type is required'),
  method: Yup.string().required('Method is required')
})

const AddItemMaterialRequest = Yup.object().shape({
  item_id: Yup.string().required('Item is required'),
  batch_id: Yup.string().required('Batch is required'),
  pack: Yup.number().min(1, 'Pack minimum 1').required('Pack is required')
})

const CreateTransferItemIssueSchema = Yup.object().shape({
  type: Yup.string()
    .oneOf(['karantina', 'reject'], 'Invalid status')
    .required('Type is required')
})

const CreateStockAdjustmentSchema = Yup.object().shape({
  warehouse_id: Yup.string().required('Warehouse ID is required'),
  note: Yup.string().required('Note is required')
})

const CreateStockOpnamePackingSchema = Yup.object().shape({
  type: Yup.string()
    .oneOf(['create', 'update'], 'Invalid status')
    .required('Type is required'),
  opname_id: Yup.string().when('type', {
    is: 'update',
    then: (schema) => schema.required('Opname ID is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  warehouse_id: Yup.string().required('Warehouse ID is required'),
  notes: Yup.string(),
  items: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string().when('type', {
          is: 'update',
          then: (schema) => schema.required('ID item is required'),
          otherwise: (schema) => schema.notRequired()
        }),
        item_id: Yup.string().required('Item ID is required'),
        item_name: Yup.string().required('Item name is required'),
        total_pack: Yup.number().when('type', {
          is: 'update',
          then: (schema) => schema.required('Total pack is required'),
          otherwise: (schema) => schema.notRequired()
        }),
        checked_pack: Yup.number().when('type', {
          is: 'update',
          then: (schema) => schema.required('Checked pack is required'),
          otherwise: (schema) => schema.notRequired()
        }),
        status: Yup.string().when('type', {
          is: 'update',
          then: (schema) => schema.required('Status is required'),
          otherwise: (schema) => schema.notRequired()
        })
      })
    )
    .test('min-items', 'Please add at least one item', (value) => {
      return value && value.length > 0
    })
    .required('Items are required')
})

const CreateMaterialRejectSchema = Yup.object().shape({
  dc_id: Yup.string().required('DC ID is required'),
  series_number: Yup.string().required('Series number is required'),
  items: Yup.array()
    .of(
      Yup.object().shape({
        pick_up_command_id: Yup.string().required(
          'Pick up command ID is required'
        ),
        item_batch_id: Yup.string().required('Item batch ID is required'),
        area_id: Yup.string().required('Area ID is required'),
        total_qty: Yup.number().required('Total qty is required'),
        total_pack: Yup.number().nullable(),
        remark: Yup.string().nullable()
      })
    )
    .test('min-items', 'Please add at least one item', (value) => {
      return value && value.length > 0
    })
    .required('Items are required')
})

export {
  AddItemMaterialRequest,
  AddItemProblemSjSchema,
  AddPrTypeSchemaPo,
  AddPrTypeSchemaPr,
  AreaAddEditSchema,
  BatchAddEditSchema,
  BranchUpdateSchema,
  CategoryAddEditSchema,
  ChangePasswordSchema,
  CreateMasterPalet,
  CreateSoSjSchema,
  DriverAddSchema,
  DriverEditSchema,
  MapEditorGroundSchema,
  MapEditorSchema,
  MapEditorStagingAreaSchema,
  ModalUpdateVehiclePR,
  PurchaseReceiptCreateImportSchema,
  PurchaseReceiptCreateLocalSchema,
  RackAddSchema,
  RackAddEditSchema,
  RoleAddEditSchema,
  SectorUpdateSchema,
  StagingAreaAddSchema,
  UpdateSoSjSchema,
  UserAddSchema,
  UserEditSchema,
  VehicleAddEditSchema,
  deliveryConfirmationUpdateItem,
  dimensionSchema,
  expeditionRentAddEditSchema,
  loginSchema,
  updateCOA,
  updateCOACrossDockOrTypeExternal,
  CreateTransferItemIssueSchema,
  CreateStockAdjustmentSchema,
  UpdateRequestSjSchema,
  PurchaseOrderPackingCreateSchema,
  CreateStockOpnamePackingSchema,
  CreateMaterialRejectSchema
}
